import { render, staticRenderFns } from "./ProductsList.vue?vue&type=template&id=428d812c&scoped=true"
import script from "./ProductsList.vue?vue&type=script&lang=js"
export * from "./ProductsList.vue?vue&type=script&lang=js"
import style0 from "./ProductsList.vue?vue&type=style&index=0&id=428d812c&prod&scoped=true&lang=css"
import style1 from "./ProductsList.vue?vue&type=style&index=1&id=428d812c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428d812c",
  null
  
)

export default component.exports